/** @module ssz */

// Number of bytes per chunk.
/** @ignore */
export const BYTES_PER_CHUNK = 32;

// Number of bytes per serialized length prefix.
/** @ignore */
export const BYTES_PER_LENGTH_PREFIX = 4;
